import { AddressEditingWarningContainer } from './AddressEditingWarningContainer';
import { attachReactComponent } from '../../common/attachReactComponent';

attachReactComponent(AddressEditingWarningContainer);
